import React, { forwardRef, useEffect, useState } from 'react'
import classnames from 'classnames'
import { Button, BUTTON_THEME, BUTTON_SIZE, Icon } from '@st-operations/uikit/src/v2/index.js'

import Popup from '_components/popup/index.jsx'
import CustomAttributesForm from '../custom-attributes-form/index.jsx'

import './styles.scss'

const AddCustomAttribute = (
  { className, value, onClear = () => null, onUpsert = () => null },
  ref
) => {
  const [current, setCurrent] = useState()

  useEffect(() => {
    setCurrent(value)
  }, [value])

  return (
    <div className={classnames('add-custom-attribute', className)}>
      <div
        ref={ref?.current?.setTriggerRef}
        className="add-custom-attribute__trigger"
        onClick={() => ref.current.open()}
      >
        <Icon icon="plus2" type="fill" width={16} height={16} color="currentColor" />
        <span>New Custom Attribute</span>
      </div>
      <Popup ref={ref} position="top right" onClose={onClear} height={372}>
        <div className="add-custom-attribute__dialog">
          <CustomAttributesForm
            className="add-custom-attribute__edit-form"
            value={current}
            onChange={(value) => setCurrent(value)}
          />
          <footer>
            <Button
              className="add-custom-attribute__footer-button"
              onClick={() => {
                ref.current.close()
                onClear()
              }}
              theme={BUTTON_THEME.GHOST}
              size={BUTTON_SIZE.SMALL}
            >
              Cancel
            </Button>
            <Button
              className="add-custom-attribute__footer-button"
              onClick={() => {
                onUpsert(current, value)
                onClear()
              }}
              size={BUTTON_SIZE.SMALL}
            >
              Save
            </Button>
          </footer>
        </div>
      </Popup>
    </div>
  )
}

export default forwardRef(AddCustomAttribute)
